import React from 'react';
import styles from './loading.pcss';

const Loading = (props) => (
	<div className={styles.loading}></div>
);

export default Loading;


// WEBPACK FOOTER //
// ./src/components/loading.js